/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_Last_UpdatedInputs */

const tr_kvkkbasvuru_last_updated = /** @type {(inputs: Kvkkbasvuru_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`28 Mayıs 2026`)
};

const en_kvkkbasvuru_last_updated = /** @type {(inputs: Kvkkbasvuru_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`28 May 2026`)
};

const de_kvkkbasvuru_last_updated = /** @type {(inputs: Kvkkbasvuru_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`28. Mai 2026`)
};

const ru_kvkkbasvuru_last_updated = /** @type {(inputs: Kvkkbasvuru_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`28 мая 2026 г.`)
};

/**
* | output |
* | --- |
* | "28 May 2026" |
*
* @param {Kvkkbasvuru_Last_UpdatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_last_updated = /** @type {((inputs?: Kvkkbasvuru_Last_UpdatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_Last_UpdatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_last_updated(inputs)
	if (locale === "de") return de_kvkkbasvuru_last_updated(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_last_updated(inputs)
	return tr_kvkkbasvuru_last_updated(inputs)
});